import React from "react";
import { useLocation } from "react-router-dom";
import SeoHead from "./SeoHead";
import { useSportWorkspace } from "../hooks/useSportWorkspace";
import { getWorkspaceSeo } from "../utils/seoCatalog";

const WorkspaceSeo = () => {
  const { sport, destination } = useSportWorkspace();
  const { pathname } = useLocation();
  return <SeoHead {...getWorkspaceSeo({ sport, destination, pathname })} />;
};

export default WorkspaceSeo;
